import { memo } from 'react';
import { StickyNotePrimitive } from './primitive';
import { useI18n } from '@/providers/i18n';
import { areNodePropsEqual } from '../are-node-props-equal';

export type StickyNoteNodeProps = {
  type: string;
  data: {
    text?: string;
    color?: string;
    width?: number;
    height?: number;
  };
  id: string;
  selected?: boolean;
};

export const StickyNoteNode = memo((props: StickyNoteNodeProps) => {
  const { t } = useI18n();
  return <StickyNotePrimitive {...props} title={t('Sticky Note')} />;
}, areNodePropsEqual);
StickyNoteNode.displayName = 'StickyNoteNode';
